import {api} from "../api";
import Cookies from 'js-cookie';
import Registration from "../../components/registration.vue"
import { Notice } from '../utils/notice';

export default {
    name: 'Header',

    components: {
        Registration
    },

    data() {
        return {
            isUser: null,
            isBackend: false,
            firstname: '',
            lastname: '',
            profile_photo: '',
            phone: '',
            isChatActive: false,
            isChatHaveNewMessage: false,
            isChatMenu: false,
            isChatMenuOpen: false,
            isRegChat: false,
            isCallbackOrdered: false,
            isRegCallback: false,
            displayedUserBalance: 0,
            userBalance: 0,
            isShowArticleBanner: false,
            articleBannerTimeout: 0,
            isShowTelegramBanner: false,
            telegramBannerTimeout: 0,
            isShowArticleBannerReg: false,
            isShowMobileIosBanner: false,
            scrollTop: true,
            scrollPosition: 0,
            isShowCookiesBanner: false,
        }
    },

    computed: {
        photo() {
            if (this.profile_photo) {
                return this.profile_photo;
            }
            return '/img/svg/profile-photo-placeholder.svg';
        },

        name() {
            if (this.lastname && this.firstname) {
                return this.firstname + ' ' + this.lastname.substring(0, 1) + '.';
            }
            return 'Профиль';
        },

        isLk() {
            const path = location.pathname;
            return path.includes('declaration') || path.includes('profile') || path.includes('userfiles')
        },
    },

    methods: {
        handleMenuButtonClick() {
            this.isChatActive && this.toggleChat();
            this.toggleMobileMenu();
        },

        toggleMobileMenu() {
            document.body.classList.toggle('mobile-menu-opened');
        },

        getProfile() {
            return api.get('/v3/user/profile')
            .then(res => {
                let data = res.data.data;

                if (Object.keys(res.data.errors).length) return;

                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        this.hasOwnProperty(key) ? this[key] = data[key] : null;
                    }
                }
                
                this.isUser = true;
                this.userBalance = data.balance;

                this.checkBackend();

                const profileParameters = {};

                const timeZone = new Date().getTimezoneOffset()/60 * -1;
                if (data.hasOwnProperty('time_zone') && timeZone !== data.time_zone ) {
                    profileParameters['time_zone'] = timeZone;
                }

                const ga_cid = Cookies.get('_ga');
                const ga_cid_without_version = ga_cid ? ga_cid.replace('GA1.1.', '').replace('GA1.2.', '').replace('GA1.3.', '').replace('GA1.4.', '') : '';
                if (ga_cid && data.google_cids && !data.google_cids.includes(ga_cid_without_version)) {
                    profileParameters['ga_cid'] = ga_cid;
                }

                const ya_cid = Cookies.get('_ym_uid');
                if (ya_cid && data.yandex_cids && !data.yandex_cids.includes(ya_cid)) {
                    profileParameters['ya_cid'] = ya_cid;
                }

                if (this.objectLength(profileParameters)) {
                    api.post('/v3/user/profile', profileParameters);
                }

                if (data.hasOwnProperty('policy') && !data.policy && location.pathname.indexOf('/eula-accept') === -1 && location.pathname.indexOf('/documents/') === -1) {
                    location = '/eula-accept/';
                } else if ((!data.phone || !data.email) && location.pathname.indexOf('/profile') === -1) {
                    sessionStorage.setItem('profile-data-error', true);
                    location = '/profile';
                }

                try {
                    ym(process.env.YANDEX_COUNTER_ID, 'userParams', {
                        partner: data.partner,
                        UserID: data.uid
                    });
                } catch(e) {
                    
                }

                document.dispatchEvent(new Event('loadComponents'));

                clearTimeout(this.telegramBannerTimeout);
                if (this.isShowTelegramBanner) {
                    this.hideTelegramBanner();
                }
            }).catch(err => {
                if (err.response && err.response.status === 401) {
                    Cookies.remove('user_token', {domain: process.env.COOKIE_DOMAIN});
                }
            });
        },

        logout() {
            Cookies.remove('user_token', {
              domain: process.env.COOKIE_DOMAIN
            });
            setTimeout(() => {
              location = '/logout';
            }, 200);
        },

        toggleChat() {   
            this.isChatMenuOpen = false;   

            document.body.classList.toggle('chat-opened');
            document.dispatchEvent(new Event('toggleChat'));

            if (!this.isChatActive && this.isChatHaveNewMessage) {
                this.isChatHaveNewMessage = false;
                document.querySelector('.js-chat-button').classList.remove('new-message');
                document.querySelector('.js-chat-popup').classList.remove('chat-popup');
            }

            document.body.classList.contains('mobile-menu-opened') && document.body.classList.remove('mobile-menu-opened');

            this.isChatActive = !this.isChatActive;
        },

        toggleChatMenu() {
            this.isChatMenuOpen = !this.isChatMenuOpen;
            this.isChatMenu = true;
            this.isCallbackOrdered = false;
            this.clearChatMenu();

            if (this.isChatActive) {
                this.isChatMenu = false;
                this.toggleChat();
            }

            if (this.isChatHaveNewMessage) {
                document.querySelector('.js-chat-popup').classList.remove('chat-popup');
            }
        },
        
        showChatReg() {
            this.isChatMenu = false;
            this.isRegChat = true;
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'header_button_reg_chat' }}));
        },

        showCallbackReg() {
            this.isChatMenu = false;
            this.isRegCallback = true;
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'header_button_reg_callback' }}));
        },

        clearChatMenu() {
          this.isRegCallback = false;
          this.isRegChat = false;
        },

        createCallback() {
            api.post('/callback/requestCall')
            .then(() => {
                this.isCallbackOrdered = true;
                this.isChatMenu = false;
                this.clearChatMenu();
            });
        },

        messageReceived() {
            if (this.isChatActive || this.isChatHaveNewMessage) return;
            this.isChatHaveNewMessage = true;
            document.querySelector('.js-chat-button').classList.add('new-message');
            document.querySelector('.js-chat-popup').classList.add('chat-popup');
        },

        checkBackend() {
            api.get('/user/availableroles')
            .then(res => {
                let roles = res.data;
                if (roles.length) {
                    this.isBackend = true;
                }
            });
        },

        objectLength(value) {
            if (typeof(value) !== 'object') {
                return 0;
            }
            return Object.keys(value).length;
        },

        initActionBlocks() {
            let currentLocation = window.location.pathname;
            if (currentLocation.indexOf('/article') !== 0 &&
                currentLocation.indexOf('/authors') !== 0 &&
                currentLocation.indexOf('/news') !== 0 &&
                currentLocation.indexOf('/declarations') !== 0 &&
                !document.querySelector('#article.article-page')
            ) {
                return;
            } 
            
            let location = 1;
            if (currentLocation.indexOf('/declarations') === 0) {
                this.isUser ? location = 2 : location = 4;
            }
            
            api.get(`/cta/?location=${location}`)
            .then(res => {
                let blocksInfo = res.data;
                for (let i = 0; i < blocksInfo.length; i++) {
                    let blockInfo = blocksInfo[i];

                    if (blockInfo.position === 1) {
                        this.createTopActionBlock(blockInfo);
                    }

                    if (blockInfo.position === 2) {
                        this.createBottomActionBlock(blockInfo);
                    }
                }
            }).catch(() => {
                
            });
        },

        createActionBlock(blockInfo, cssClass, parentBlockForAction) {
            let actionBlock = document.createElement('div');
            actionBlock.classList.add(cssClass);

            let actionBlockText = document.createElement('p');
            actionBlockText.textContent = blockInfo.content;
            actionBlockText.classList.add('cta-text');
            actionBlock.appendChild(actionBlockText);

            let actionBlockLink = document.createElement('a');
            actionBlockLink.textContent = blockInfo.button_text;
            actionBlockLink.setAttribute('href', blockInfo.url);
            actionBlockLink.classList.add('button', 'button-cta');
            actionBlock.appendChild(actionBlockLink);

            parentBlockForAction.appendChild(actionBlock);
        },

        createTopActionBlock(blockInfo) {
            let header = document.querySelector('#header');

            if (!header) {
                return;
            }

            this.createActionBlock(blockInfo, 'action-block-top', header);
            setTimeout(() => {
                document.body.classList.add('show-action-block-top');
            }, 50);
            
        },

        createBottomActionBlock(blockInfo) {
            let targetBlock = null;

            let articleBlock = document.querySelector('.article-action-block');
            if (articleBlock) {
                targetBlock = articleBlock;
                articleBlock.classList.add('showed');
            }

            if (!targetBlock) {
                let relatedBlock = document.querySelector('.related-articles-block');
                if (relatedBlock) {
                    let blockWrap = document.createElement('div');
                    relatedBlock.parentNode.insertBefore(blockWrap, relatedBlock);
                    targetBlock = blockWrap;
                }
            }

            if (!targetBlock) {
                let footer = document.querySelector('.footer');
                if (footer) {
                    let blockWrap = document.createElement('div');
                    footer.parentNode.insertBefore(blockWrap, footer);
                    targetBlock = blockWrap;
                }
            }

            if (!targetBlock) {
                return;
            }

            this.createActionBlock(blockInfo, 'action-block-bottom', targetBlock);
        },

        checkChatAndCallback() {
            const currentUrl = new URL(window.location.href);
            const openParameter = currentUrl.searchParams.get('open');

            if (openParameter === 'chat') {
                this.toggleChatMenu();
                
                if (this.isUser) {
                    this.toggleChat();
                } else {
                    this.showChatReg();
                    localStorage.setItem('callback_url', window.location.href);
                }
            }

            if (openParameter === 'call') {
                this.toggleChatMenu();

                if (this.isUser) {
                    this.createCallback();
                } else {
                    this.showCallbackReg();
                }
            }

            if (openParameter === 'startchat') {
                this.toggleChatMenu();
                document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'startchat' }}));
            }

            if (openParameter === 'traderorders') {
                const block = document.querySelector('.trader-concierge');
                block && this.scrollToElement(block);
            }
        },
        
        scrollToElement(element) {
            if (element) {
                requestAnimationFrame(() => {
                    const yOffset = -document.querySelector('#header').offsetHeight;
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset - 30;

                    window.scrollTo({top: y, behavior: 'smooth'});
                });
            }
        },

        scrollToTurnkey() {
            let turnkey = document.querySelector('.home-turnkey');
            this.scrollToElement(turnkey);
        },

        scrollFromHeader() {
            if (document.body.classList.contains('mobile-menu-opened')) {
                this.handleMenuButtonClick();
            }
            
            const homeTurnkey = document.getElementById('home-turnkey')
            
            if (homeTurnkey) {
                this.scrollToElement(homeTurnkey);
                return
            }

            location = '/#home-turnkey';
        },

        initMobileMenu() {
            const mobileMenuParents = document.querySelectorAll('.mobile-menu-nav .has-children > .header-link');
            mobileMenuParents.forEach(item => {
                item.addEventListener('click', this.mobileItemClick);
            });
        },

        mobileItemClick(e) {
            e.preventDefault();
            let menuItem = e.target.parentNode;
            if (menuItem.classList.contains('active')) {
                let parentItem = menuItem.parentNode.parentNode;
                let parentMenu = parentItem.parentNode;

                let items;
                if (parentMenu.classList.contains('root-menu')) {
                    items = parentMenu.querySelectorAll('.active, .hidden-item, .selected-item');
                } else {
                    let subParent = menuItem.parentNode;
                    items = subParent.querySelectorAll('.active, .hidden-item, .selected-item');
                }
                items.forEach(item => {
                    item.classList.remove('active');
                    item.classList.remove('hidden-item');
                    item.classList.remove('selected-item');
                });

                parentItem.classList.remove('selected-item');
            } else {
                let parentItem = menuItem.parentNode.parentNode;
                let parentMenu = parentItem.parentNode;

                let items = parentMenu.querySelectorAll('li');
                items.forEach(item => {
                    item.classList.add('hidden-item');
                });

                parentItem.classList.remove('hidden-item');
                parentItem.classList.add('selected-item');

                let exceptItems = menuItem.querySelectorAll('li');
                exceptItems.forEach(item => {
                    item.classList.remove('hidden-item');
                });

                menuItem.classList.add('active');
                menuItem.classList.remove('hidden-item');
            }
        },

        checkUserBalance() {
            this.displayedUserBalance = 0;
            
            api.get('/referal/user/balance')
                .then((res) => {
                    this.displayedUserBalance = res.data.balance + this.userBalance;
                })
                .catch((error) => {
                    console.log('check balance error: ', error);
                });
        },

        showArticleBanner() {
            this.isShowArticleBanner = true;
            document.body.style.overflow = 'hidden';
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'article_popup_start' }}));
        },

        closeArticleBanner() {
            this.hideArticleBanner();
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'article_popup_close' }}));
        },

        hideArticleBanner() {
            this.isShowArticleBanner = false;
            document.body.style.overflow = 'unset';
        },

        initArticleBanner() {
            if (!document.querySelector('#new-article, #article.article-page')) {
                return;
            }

            this.articleBannerTimeout = setTimeout(() => {
                this.showArticleBanner();
            }, 25000);
        },

        articleBannerRegCallback() {
            this.hideArticleBanner();
            this.toggleChat();
        },

        showArticleBannerReg() {
            this.isShowArticleBannerReg = true;
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'article_popup_open_reg' }}));
        },

        addYaScript() {
            if ( location.href === process.env.DOMAIN + "/" || location.pathname.indexOf("/article") === 0) {
                const script = document.createElement("script");
                script.setAttribute(
                    "src",
                    "https://yastatic.net/s3/passport-sdk/autofill/v1/sdk-suggest-with-polyfills-latest.js"
                );
                script.onload = () => {
                    this.initYandexWidget();
                };
                document.head.appendChild(script);
            }
        },

        initYandexWidget() {
            window.YaAuthSuggest.init({
                client_id: '5f5ef585dde544ac9dccd1af6daf0889',
                response_type: 'token',
                redirect_uri: process.env.DOMAIN + '/yaid/token'
            }, location.href)
                .then(({ handler }) => handler())
                .then(data => {
                    const body = {
                        nid: localStorage.getItem("nanoId"),
                        apptoken: process.env.TOKEN,
                    };

                    let inviteCode = Cookies.get("invite_code");
                    if (inviteCode) {
                        body["invite_refer"] = inviteCode;
                    }

                    let refer = Cookies.get("fv_refer");
                    if (refer) {
                        body["fv_referrer"] = refer;
                    }

                    let fv_location = Cookies.get("fv_location");
                    if (fv_location) {
                        body["fv_location"] = fv_location;
                    }

                    let fv_date = Cookies.get("fv_date");
                    if (fv_date) {
                        body["fv_date"] = fv_date;
                    }

                    let ga_cid = Cookies.get("_ga");
                    if (ga_cid) {
                        body["ga_cid"] = ga_cid;
                    }

                    let ya_cid = Cookies.get("_ym_uid");
                    if (ya_cid) {
                        body["ya_cid"] = ya_cid;
                    }

                    api.post("/yaid/authFast", {token: data.access_token, state: body})
                        .then((res) => {
                            Cookies.set("user_token", res.data.jtc, { expires: 3650, domain: process.env.COOKIE_DOMAIN, secure: true });

                            if (res.data.is_reg) {
                                document.dispatchEvent( new CustomEvent("pushGoal", { detail: { goal: "reg_button" }}));
                                document.dispatchEvent( new CustomEvent("pushGoal", { detail: { goal: "reg_popup_yandex"}}));
                            } else {
                                document.dispatchEvent( new CustomEvent("pushGoal", { detail: { goal: "login_popup_yandex"}}));
                            }

                            location = "/declarations";
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                })
                .catch(error => {
                    console.log('Обработка ошибки', error)
            })
        },

        closeMobileIosBanner() {
            this.isShowMobileIosBanner = false;
        },

        checkScroll() {
            if (this.isShowMobileIosBanner) {
                let positionY = window.pageYOffset || document.documentElement.scrollTop;

                if (positionY > this.scrollPosition) {
                    this.scrollTop = false;
                } else if (positionY < this.scrollPosition) {
                    this.scrollTop = true;
                }

                this.scrollPosition = positionY <= 0 ? 0 : positionY;
            }
        },

        initMobileIosBanner() {
            if (location.href !== process.env.DOMAIN + '/' && location.pathname.indexOf("/article") !== 0) {
                return;
            }

            if (!['iPad', 'iPhone', 'iPad'].includes(navigator.platform)) {
                return;
            }

            this.isShowMobileIosBanner = true;
            window.addEventListener('scroll', this.checkScroll);
        },

        hideTelegramBanner() {
            this.isShowTelegramBanner = false;
            document.body.style.overflow = 'unset';
        },

        showTelegramBanner() {
            this.isShowTelegramBanner = true;
            document.body.style.overflow = 'hidden';
            Cookies.set('articles_telegram_sub', 'showed', {domain: process.env.COOKIE_DOMAIN, secure: true});
            document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'article_tg_banner_show' }}));
        },

        initTelegramBanner(time) {
            this.telegramBannerTimeout = setTimeout(() => {
                this.showTelegramBanner();
            }, time);
        },
        
        handleAcceptCookiesButton() {
            this.isShowCookiesBanner = false;

            api.post('/v3/user/setAcceptCookie', {
                nid: localStorage.getItem('nanoId'),
                accept_uri: location.href
            })
                .catch(() => undefined);
        },

        checkCookiesAcception() {
            api.get(`/accept_cookie/${localStorage.getItem('nanoId')}/`)
                .then((res) => {
                    this.isShowCookiesBanner = !res.data;
                })
                .catch(() => undefined);
        }
    },

    created() {
        const article = document.querySelector('#new-article, #article.article-page');

        if (Cookies.get('user_token')) {
            this.getProfile()
            .then(() => {
                this.initActionBlocks();
                this.checkChatAndCallback();
                this.checkUserBalance()
                if (!this.isUser) {
                    // this.addYaScript()
                }
            });
        } else {
            this.isUser = false;
            this.initActionBlocks();
            this.checkChatAndCallback();
            
            if (!Cookies.get('articles_telegram_sub') && article) {
                this.initTelegramBanner(10000);
            }
            
            if (article) {
                document.addEventListener('scroll', () => {
                    clearTimeout(this.telegramBannerTimeout)
                    this.initTelegramBanner(30 * 60 * 1000);
                });
            }


            // this.initArticleBanner();
            // this.addYaScript()
        }

        this.initMobileIosBanner();
        this.checkCookiesAcception()

        document.addEventListener('headerGetProfile', () => {
            this.getProfile()
        });

        document.addEventListener('messageReceived', () => {
            this.messageReceived()
        });

        document.addEventListener('headerHideMobileMenu', () => {
            document.querySelector('body').classList.remove('mobile-menu-opened');
        });

        document.addEventListener('headerToggleChat', () => {
            this.toggleChat();
        });

        document.addEventListener('headerToggleChatMenu', () => {
            this.toggleChatMenu();
        });
    }
}
